import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';

import AuthProvider from '@source/components/AuthProvider';
import Layout from '@source/components/Layout';
import { ApolloClient } from '@source/contexts';
import { client } from '@source/services/graphql';
import history from '@source/services/history';
import { getReduxStore } from '@source/redux';

const Application = () => (
  <ApolloProvider client={client}>
    <ApolloHooksProvider client={client}>
      <ApolloClient.Provider value={{ client }}>
        <Router history={history}>
          <Provider store={getReduxStore()}>
            <AuthProvider>
              <Route path="/" component={Layout} />
            </AuthProvider>
          </Provider>
        </Router>
      </ApolloClient.Provider>
    </ApolloHooksProvider>
  </ApolloProvider>
);

export default Application;
